import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import DateRangePicker from "react-bootstrap-daterangepicker";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarAlt, faTimes } from "@fortawesome/free-solid-svg-icons";
import moment from "moment";
import { Card, Button, Modal } from "react-bootstrap";
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min";
import { Snackbar, TextField } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import "../../../utils/Css/Marketing.css";
import "../../../utils/Css/Campagne.css";
import publicationService from "./../../../services/MarketingService/PublicationService";
import clientService from "./../../../services/MarketingService/ClientService";
import getCurrentUserId from "../../../reduxSaga/sagas/requests/currentUserId";

function TablePublication() {
  const [data, setData] = useState([]);
  const navigate = useNavigate();
  const [statut, setStatut] = useState(data.statut);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false); //for buttons
  const [piecesJointesdata, setPiecesJointesdata] = useState([]);
  const [typesData, setTypesData] = useState([]);
  const [genresData, setGenresData] = useState([]);
  const [canalDiffusionsData, setCanalDiffusionsData] = useState([]);
  const [objectifsData, setObjectifsData] = useState([]);
  const [statutsData, setStatutsData] = useState([]);
  const [selectedPublication, setSelectedPublication] = useState(null);
  const [publicationDate, setpublicationDate] = useState(null);
  const [inputValue, setInputValue] = useState(null);
  const [buttonDisabled, setButtonDisabled] = useState(true);
  const formattedDateTime = moment(data.publicationDate).format(
    "yyyy-MM-ddThh:mm"
  );

  //notification
  const [success, setSuccess] = useState(null);
  const [erreur, setErreur] = useState(null);
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();
  const [openSuccessAlert, setOpenSuccessAlert] = useState(false);
  const [successAlertText, setSuccessAlertText] = useState();

  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorAlert(false);
  };

  const handleSuccessClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSuccessAlert(false);
  };

  // change date de publication
  const onChangeStartDate = (event) => {
    setFormData({
      ...formData,
      publicationDate: event.target.value,
    });
  };
  // state for filter parameters
  const [filter, setFilter] = useState({
    idUser: getCurrentUserId(),
    nom: "",
    canalDiffusion: "",
    type: "",
    statut: "",
    startDate: "",
    endDate: "",
  });

  // Fonction pour exporter les données filtrées au format CSV
  const handleExportCSV = () => {
    const currentDateTime = new Date().toISOString().replace(/[-:.]/g, "");
    const csvData = data.map(
      (item) => `${item.nom},${item.type},${item.canalDiffusion}`
    ); // Remplacez les propriétés d'objet par celles de vos données
    const csvContent = `${csvData.join("\n")}`;
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = `Publications_${currentDateTime}.csv`; // Nom du fichier CSV à télécharger avec la date et l'heure actuelles
    link.click();
  };

  /****************   methodes for approuver or rejected publicatiod **********************/

  const handleApprouvedPublication = async (event) => {
    try {
      event.preventDefault();
      const id = selectedPublication.id;
      const response = await publicationService.approuvedStatut(
        id,
        userId,
        userRoles
      );
      setData(response);
      setIsButtonDisabled(true);
      filterData();
      setOpenSuccessAlert(true);
      setSuccessAlertText("Publication approuvée avec succès");
    } catch (error) {
      console.log(error);
      setOpenErrorAlert(true);
      setErrorAlertText("Erreur :" + error);
    }
  };

  const handleRjectedPublication = (event) => {
    const id = selectedPublication.id;
    publicationService
      .rejectStatut(id, userId, userRoles)
      .then((response) => {
        setData(response);
        setIsButtonDisabled(true);
        filterData();
        setOpenSuccessAlert(true);
        setSuccessAlertText("Publication rejetée avec succès");
      })
      .catch((error) => {
        console.log(error);
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur :" + error);
      });
  };

  /****************   /.methodes for approuver or rejected publicatiod **********************/

  //Delete modal
  // Gérer les changements de valeur dans l'entrée
  const handleInputChangeDelete = (event) => {
    setInputValue(event.target.value);

    // Désactiver le bouton de suppression si l'entrée est vide ou différente de "DELETE"
    if (event.target.value !== "DELETE") {
      setButtonDisabled(true);
    } else {
      setButtonDisabled(false);
    }
  };
  //DeleteModal
  const [show, setShow] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const handleClose = () => setShow(false);

  const handleDeletePublication = (row) => {
    setSelectedRow(row);
    setShow(true);
  };

  const handleConfirmDelete = async () => {
    try {
      await publicationService.supprimerPublication(selectedRow.id);
      const newData = data.filter((item) => item.id !== selectedRow.id);
      setData(newData);
      setShow(false);
      // Effacer la valeur de l'input "DELETE" après le clique sur le button supprimer
      setInputValue("");
    } catch (error) {
      console.error(error);
    }
  };

  //EditModal
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({
    nom: "",
    objectif: "",
    contenu: "",
    canalDiffusion: "",
    type: "",
    genreCible: "",
    ageCible: "",
    lieuCible: "",
    publicationDate: "",
    PiecesJoints: "",
    idPublication: "",
  });
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };
  // Gérer l'édition de la publication
  const handleEditPublication = (publication) => {
    setSelectedPublication(publication);
    setShowModal(true);
    setFormData({
      nom: publication.nom,
      objectif: publication.objectif,
      contenu: publication.contenu,
      canalDiffusion: publication.canalDiffusion,
      type: publication.type,
      publicationDate: moment(publication.publicationDate).format(
        "YYYY-MM-DDTHH:mm"
      ),
      PiecesJoints: publication.PiecesJoints,
      statut: publication.statut,
      idPublication: publication.idPublication,
      genreCible: publication.genreCible,
      ageCible: publication.ageCible,
      lieuCible: publication.lieuCible,
    });
  };
  // Gérer la sélection de fichiers joints
  const handlePieceJointeChange = (event) => {
    setPiecesJointesdata([...piecesJointesdata, event.target.files[0]]);
  };

  // Supprimer le dernier fichier joint de la liste
  const handleDeletePieceJointe = () => {
    // Create a copy of the piecesJointesdata array
    const newPiecesJointesData = [...piecesJointesdata];

    // Remove the last item from the array
    newPiecesJointesData.pop();

    // Update the state with the new array
    setPiecesJointesdata(newPiecesJointesData);
  };

  // Fonction utilitaire pour extraire l'ID de l'utilisateur du token JWT
  const user = JSON.parse(localStorage.getItem("user"));
  // Récupérer l'ID de l'utilisateur connecté
  const userId = user?.token.idUser;
  // Récupérer le rôle de l'utilisateur connecté/*  */
  const userRoles = user?.token.nameRole;
  /****************  methode update publication **********************/

  const handleUpdatePublication = async (event) => {
    event.preventDefault();

    const {
      nom,
      contenu,
      canalDiffusion,
      type,
      genreCible,
      lieuCible,
      ageCible,
      objectif,
      publicationDate,
      idPublication,
    } = formData;

    // Vérifier que tous les champs existent
    if (
      !nom ||
      !objectif ||
      !type ||
      !canalDiffusion ||
      !contenu ||
      !genreCible ||
      !lieuCible ||
      !ageCible ||
      !publicationDate
    ) {
      setOpenErrorAlert(true);
      setErrorAlertText("Veuillez renseigner tous les champs !");
      return;
    }

    /*     console.log("piecesJointesdata : " + piecesJointesdata.name);
    console.log(
      "selectedPublication.piecesJointesdata : " +
        selectedPublication.piecesJointesdata
    ); */

    if (
      nom === selectedPublication.nom &&
      objectif === selectedPublication.objectif &&
      type === selectedPublication.type &&
      canalDiffusion === selectedPublication.canalDiffusion &&
      contenu === selectedPublication.contenu &&
      lieuCible === selectedPublication.lieuCible &&
      ageCible === selectedPublication.ageCible &&
      genreCible === selectedPublication.genreCible &&
      publicationDate ===
        moment(selectedPublication.publicationDate).format("YYYY-MM-DDTHH:mm")
      // piecesJointesdata === selectedPublication.piecesJointesdata
    ) {
      // Vérifier si les champs ont été modifiés
      setOpenErrorAlert(true);
      setErrorAlertText(
        "Veuillez modifier au moins un champ avant de soumettre le formulaire."
      );
      return;
    }

    // Vérifier si l'âge est une valeur entière
    if (!Number.isInteger(Number(ageCible))) {
      setOpenErrorAlert(true);
      setErrorAlertText("Veuillez saisir un âge valide !");
      return;
    }

    // Vérifier si l'âge est une valeur entière
    if (!Number.isInteger(Number(idPublication))) {
      setOpenErrorAlert(true);
      setErrorAlertText("Veuillez saisir id de publication valide !");
      return;
    }

    const currentDate = new Date();
    if (new Date(publicationDate) < currentDate) {
      setOpenErrorAlert(true);
      setErrorAlertText(
        "La date de publication doit être supérieure ou égale à la date actuelle !"
      );
      return;
    }

    try {
      // Mettre à jour la publication avec les nouvelles informations et les images
      const images = piecesJointesdata ? piecesJointesdata : null;
      await publicationService
        .mettreAJourPublication(formData, images, selectedPublication.id)
        .then((response) => {
          console.log(response.data.success);
          setOpenSuccessAlert(true);
          setSuccessAlertText("Enregistrement avec succées");

          setTimeout(() => {
            navigate(`/PagePublication`);
          }, 2000);
        })
        .catch((error) => {
          setOpenErrorAlert(true);
          setErrorAlertText("Erreur :" + error);
        });
      const updatedData = data.map((publication) =>
        publication.id === selectedPublication.id
          ? { ...publication, ...formData }
          : publication
      );
      setData(updatedData);
    } catch (error) {
      console.log(error);
    }
  };

  /****************  /.methode update publication **********************/

  const handleCancel = () => {
    setShowModal(false);
    setSelectedPublication(null);
  };

  //useEffect
  useEffect(() => {
    AfficherListTypes();
    AfficherListCanalDiffusion();
    AfficherListObjectifs();
    AfficherListStatus();
    AfficherListGenres();
    fetchData();
  }, []);
  useEffect(() => {
    if (success) {
      const timeoutId = setTimeout(() => {
        setSuccess(null);
      }, 2000);
      return () => clearTimeout(timeoutId);
    }
  }, [success]);

  const AfficherListObjectifs = () => {
    publicationService
      .AfficherListObjectifs()
      .then((response) => {
        setObjectifsData(response.data.success);
      })
      .catch((error) => {
        console.log(error);
        setErreur(error.message);
      });
  };
  const AfficherListStatus = () => {
    publicationService
      .AfficherListStatus()
      .then((response) => {
        setStatutsData(response.data.success);
      })
      .catch((error) => {
        console.log(error);
        setErreur(error.message);
      });
  };
  const AfficherListTypes = () => {
    publicationService
      .AfficherListTypes()
      .then((response) => {
        setTypesData(response.data.success);
      })
      .catch((error) => {
        console.log(error);
        setErreur(error.message);
      });
  };

  const AfficherListCanalDiffusion = () => {
    publicationService
      .AfficherListCanalDiffusion()
      .then((response) => {
        setCanalDiffusionsData(response.data.success);
      })
      .catch((error) => {
        console.log(error);
        setErreur(error.message);
      });
  };

  /****************  methode pour afficher genres **********************/

  const AfficherListGenres = async () => {
    try {
      const response = await clientService.AfficherListGenres();
      setGenresData(response.data.success);
    } catch (error) {
      console.log(error);
      setErreur(error.message);
    }
  };
  /**************** /. methode pour afficher genres**********************/
  const fetchData = async () => {
    try {
      const response = await publicationService.AfficherListPublications(
        getCurrentUserId()
      );
      setData(response.data.success);
    } catch (error) {
      console.log(error);
      setErreur(error.message);
    }
  };
  /****************  Pagination **********************/

  const options = {
    sizePerPage: 4,
    hideSizePerPage: true,
    hidePageListOnlyOnePage: true,
    paginationPosition: "bottom",
  };
  /****************  /.Pagination **********************/

  /****************  filtre **********************/

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilter((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleCancelDateRange = () => {
    setFilter((prevState) => ({
      ...prevState,
      startDate: "",
      endDate: "",
    }));
  };

  // update filter on date range change
  const handleDateRangeChange = (event, picker) => {
    const formattedStartDate = picker.startDate.format("yyyy-MM-DD");
    const formattedEndDate = picker.endDate.format("yyyy-MM-DD");

    setFilter((prevState) => ({
      ...prevState,
      startDate: formattedStartDate,
      endDate: formattedEndDate,
    }));
  };

  // filter data
  const filterData = () => {
    publicationService
      .getPublicationsByFiltre(
        filter.idUser,
        filter.nom,
        filter.canalDiffusion,
        filter.type,
        filter.statut,
        filter.startDate,
        filter.endDate
      )
      .then((response) => {
        setData(response.data.success);
        setSelectedPublication(null);
      })
      .catch((error) => {
        console.log(error);
        setErreur(error.message);
      });
  };

  // useEffect to fetch data based on filter parameters
  useEffect(() => {
    if (filter) {
      filterData();
    } else {
      fetchData();
    }
    //console.log(getCurrentUserId());
  }, [filter]);

  /****************  /.filtre **********************/


 const voirPublicationHandler=(idPublication)=>{
  localStorage.setItem("idPublication",idPublication);
  navigate(`/VoirPublication`)
  }
  const columns = [
    {
      dataField: "publicationDate",
      //text: <div style={{ width: "110%" }}>Date publication</div>,
      text: "Date publication",
      formatter: (cell) => {
        return new Date(cell) ? moment(cell).format("YYYY-MM-DD") : "";
      },
    },
    {
      dataField: "nom",
      text: "Nom",
    },
    {
      dataField: "objectif",
      text: "Objectif",
    },
    {
      dataField: "canalDiffusion",
      text: "Canal",
    },
    /*  {
      dataField: "statut",
      text: "Statut",
      formatter: (cellContent, row) => {
        if (row && row.statut === "terminé") {
          return <span className="badge badge-danger">{cellContent}</span>;
        } else {
          return <span className="badge badge-success">{cellContent}</span>;
        }
      },
    }, */

    {
      dataField: "statut",
      text: "Statut",
      formatter: (cellContent, row) => {
        if (row && row.statut === "terminé") {
          return (
            <div class="status">
              <span class="danger">{cellContent}</span>
            </div>
          );
        } else {
          return (
            <div class="status">
              <span class="success">{cellContent}</span>
            </div>
          );
        }
      },
    },
    {
      dataField: "modifier",
      text: <div className="d-flex justify-content-center">Modifier</div>,
      formatter: (cellContent, row) => {
        return (
          <div className="d-flex justify-content-center">
            <button
              style={{ width: 40 }}
              className="btn bg-gray btn-sm"
              data-toggle="modal"
              data-target="#edit-family"
              onClick={() => {
                handleEditPublication(row);
              }}
              disabled={row.statut === "terminé" || row.statut === "Rejeté"}
            >
              <i className="fas fa-pencil-alt"></i>
            </button>
          </div>
        );
      },
    },
    {
      dataField: "archiver",
      text: <div className="d-flex justify-content-center">Archiver</div>,
      formatter: (cellContent, row) => {
        return (
          <div className="d-flex justify-content-center">
            <button
              style={{ width: 40 }}
              className="btn btn-danger btn-sm"
              onClick={() => {
                if (
                  row &&
                  (row.userIdCreation === userId ||
                    (userRoles &&
                      userRoles.includes("RESPONSABLE_MARKETING")) ||
                    userRoles.includes("ADMIN") ||
                    (userRoles &&
                      userRoles.includes("RESPONSABLE_MARKETING") &&
                      row.roleUserCreation.includes("COMMUNITY_MANAGER")))
                ) {
                  handleDeletePublication(row);
                }
              }}
              disabled={
                !(
                  row &&
                  (row.userIdCreation === userId ||
                    (userRoles &&
                      userRoles.includes("RESPONSABLE_MARKETING")) ||
                    userRoles.includes("ADMIN") ||
                    (userRoles &&
                      userRoles.includes("RESPONSABLE_MARKETING") &&
                      row.roleUserCreation.includes("COMMUNITY_MANAGER")))
                ) ||
                row.statut === "terminé" ||
                row.statut === "Rejeté"
              }
            >
              <i class="fas fa-trash"></i>
            </button>
          </div>
        );
      },
    },
    {
      dataField: "VoirPlus",
      text: <div className="d-flex justify-content-center">Voir Plus</div>,
      formatter: (cellContent, row) => {
        return (
          <div className="d-flex justify-content-center">
            <button
              style={{ width: 40 }}
              class="btn bg-black btn-sm "
              onClick={() =>
               voirPublicationHandler(row.id)
              }
            >
              <i className="fas fa-chart-pie"></i>
            </button>
          </div>
        );
      },
    },
  
  ];
  // /.columns-Publication

  return (
    <>
      <div className="row">
        <div className="col-md-12">
          <div className="card">
            <div className="card-body">
              <div className="row">
                <div className="col-lg-3 col-6">
                  <label>Date</label>
                  <div className="input-group date mt-2">
                    <DateRangePicker
                      className="input-group date"
                      startDatePlaceholder="Start Date"
                      endDatePlaceholder="End Date"
                      onApply={handleDateRangeChange}
                    >
                      <div className="input-group">
                        <div className="input-group-prepend">
                          <span className="input-group-text">
                            <FontAwesomeIcon icon={faCalendarAlt} />
                          </span>
                        </div>
                        <input
                          type="text"
                          className="form-control datetimepicker-input"
                          placeholder="Select Date .."
                          value={
                            filter.startDate && filter.endDate
                              ? `${filter.startDate} - ${filter.endDate}`
                              : ""
                          }
                        />
                        {filter.startDate && filter.endDate && (
                          <div className="input-group-append">
                            <span className="input-group-text">
                              <FontAwesomeIcon
                                icon={faTimes}
                                onClick={handleCancelDateRange}
                              />
                            </span>
                          </div>
                        )}
                      </div>
                    </DateRangePicker>
                  </div>
                </div>
                <div className="col-lg-3 col-6">
                  <div className="form-group">
                    <label>Contenu</label>
                    <select
                      className="custom-select mt-2"
                      name="canalDiffusion"
                      value={filter.canalDiffusion}
                      onChange={handleFilterChange}
                    >
                      <option value="">All</option>
                      {canalDiffusionsData?.map((canalDiffusion) => (
                        <option key={canalDiffusion} value={canalDiffusion}>
                          {canalDiffusion}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="col-lg-3 col-6">
                  <div className="form-group">
                    <label>Type</label>
                    <select
                      className="custom-select mt-2"
                      name="type"
                      value={filter.type}
                      onChange={handleFilterChange}
                    >
                      <option value="">All</option>
                      {typesData?.map((type) => (
                        <option key={type} value={type}>
                          {type}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="col-lg-3 col-6">
                  <div className="form-group">
                    <label>Statut</label>
                    <select
                      className="custom-select mt-2"
                      name="statut"
                      value={filter.statut}
                      onChange={handleFilterChange}
                    >
                      <option value="">All</option>
                      {statutsData?.map((statut) => (
                        <option key={statut} value={statut}>
                          {statut}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ToolkitProvider>
        {(props) => (
          <>
            <div className="row">
              <div className="col-md-12">
                <Card className="pb-3">
                  <Card.Body>
                    <div className="d-flex justify-content-between mt-2 mb-3">
                      <div className="d-flex">
                        <input
                          className="form-control"
                          type="search"
                          placeholder="Chercher ..."
                          aria-label="Search"
                          name="nom"
                          value={filter.nom}
                          onChange={handleFilterChange}
                        />
                      </div>
                      <div>
                        <button
                          className="btn btn-dark"
                          onClick={handleExportCSV}
                        >
                          <i className="fas fa-download"></i> Télécharger CSV
                        </button>
                      </div>
                    </div>

                    <div className="card-body p-0">
                      <BootstrapTable
                        className="table table-bordered"
                        keyField="id"
                       
                        pagination={paginationFactory(options)}
                        defaultSorted={[
                          { dataField: "createdDate", order: "asc" },
                        ]}
                        faultSortDirection="asc"
                        noDataIndication={() => "No data found"}
                        data={data}
                        columns={columns}
                      />
                    </div>
                  </Card.Body>
                </Card>
              </div>
            </div>
          </>
        )}
      </ToolkitProvider>

      {/**********************Delete Modal */}
      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header>
          <Modal.Title>Confirmation de suppression</Modal.Title>
          <button className="close">
            <FontAwesomeIcon icon={faTimes} closeButton onClick={handleClose} />
          </button>
        </Modal.Header>
        <Modal.Body>
          Êtes-vous sûr(e) de vouloir supprimer ?<br />
          <br />
          <strong>Date de publication : </strong>
          {selectedRow && selectedRow.publicationDate && (
            <>
              {new Date(selectedRow.publicationDate)
                ? moment(selectedRow.publicationDate).format("YYYY-MM-DD")
                : ""}
            </>
          )}
          <br />
          <strong>Heure de publication : </strong>
          {selectedRow && selectedRow.publicationDate && (
            <>
              {new Date(selectedRow.publicationDate)
                ? moment(selectedRow.publicationDate).format("HH:mm:ss")
                : ""}
            </>
          )}
          <br />
          <strong>Nom de publication : </strong>
          {selectedRow && selectedRow.nom}
          <br />
          <br />
          <p>
            Tapez le mot <strong>DELETE</strong> pour pouvoir supprimer cette
            publication.
          </p>
          <input
            type="text"
            className="form-control"
            placeholder="DELETE"
            value={inputValue}
            onChange={handleInputChangeDelete}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Annuler
          </Button>
          <Button
            variant="danger"
            onClick={handleConfirmDelete}
            disabled={buttonDisabled}
          >
            Supprimer
          </Button>
        </Modal.Footer>
      </Modal>
      {/********************** /.Delete Modal */}
      {/**********************Edit Modal */}
      <Modal
        show={showModal}
        onHide={handleCancel}
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <div
          className="card card-dark"
          style={{ boxShadow: "none", marginBottom: 0 }}
        >
          <div className="card-header">
            <h3 className="card-title">Modifier Publication</h3>
            <button className="close">
              <FontAwesomeIcon
                icon={faTimes}
                closeButton
                onClick={handleCancel}
                style={{ color: "white" }}
              />
            </button>
          </div>
          <form>
            <div className="card-body">
              <div className="form-group">
                <label htmlFor="exampleInputEmail1">Nom</label>
                <input
                  type="text"
                  className="form-control"
                  id="exampleInputEmail1"
                  placeholder="Nom"
                  name="nom"
                  value={formData.nom}
                  onChange={handleInputChange}
                  disabled={
                    userRoles.includes("COMMUNITY_MANAGER") &&
                    !(formData.statut === "planifié")
                  }
                />
              </div>
              <div className="form-group">
                <label htmlFor="exampleInputEmail1">Objectif</label>
                <select
                  className="custom-select"
                  id="objectif"
                  name="objectif"
                  value={formData.objectif}
                  onChange={handleInputChange}
                  disabled={
                    userRoles.includes("COMMUNITY_MANAGER") &&
                    !(formData.statut === "planifié")
                  }
                >
                  {objectifsData?.map((objectif) => (
                    <option key={objectif} value={objectif}>
                      {objectif}
                    </option>
                  ))}
                </select>
              </div>

              <div className="form-group">
                <div className="row">
                  <div className="col">
                    <label htmlFor="exampleInputEmail1">
                      Canal de diffusion
                    </label>
                    <select
                      className="custom-select"
                      id="canalDiffusion"
                      name="canalDiffusion"
                      value={formData.canalDiffusion}
                      onChange={handleInputChange}
                      disabled={
                        userRoles.includes("COMMUNITY_MANAGER") &&
                        !(formData.statut === "planifié")
                      }
                    >
                      {canalDiffusionsData?.map((canalDiffusion) => (
                        <option key={canalDiffusion} value={canalDiffusion}>
                          {canalDiffusion}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col">
                    <label htmlFor="exampleInputEmail1">Type</label>
                    <select
                      className="custom-select"
                      id="type"
                      name="type"
                      value={formData.type}
                      onChange={handleInputChange}
                      disabled={
                        userRoles.includes("COMMUNITY_MANAGER") &&
                        !(formData.statut === "planifié")
                      }
                    >
                      {typesData?.map((type) => (
                        <option key={type} value={type}>
                          {type}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>

              <div className="form-group">
                <label htmlFor="exampleInputEmail1">Contenu</label>
                <textarea
                  className="form-control"
                  rows="3"
                  placeholder="Contenu ..."
                  name="contenu"
                  value={formData.contenu}
                  onChange={handleInputChange}
                  disabled={
                    userRoles.includes("COMMUNITY_MANAGER") &&
                    !(formData.statut === "planifié")
                  }
                ></textarea>
              </div>

              <div className="form-group">
                <div className="row">
                  <div className="col">
                    <label htmlFor="exampleInputEmail1">Age Cible</label>
                    <input
                      type="text"
                      className="form-control"
                      id="ageCible"
                      placeholder="Age Cible"
                      name="ageCible"
                      value={formData.ageCible}
                      onChange={handleInputChange}
                      disabled={
                        userRoles.includes("COMMUNITY_MANAGER") &&
                        !(formData.statut === "planifié")
                      }
                    />
                  </div>
                  <div className="col">
                    <label htmlFor="exampleInputEmail1">Lieu Cible</label>
                    <input
                      type="text"
                      className="form-control"
                      id="lieuCible"
                      placeholder="Lieu Cible"
                      name="lieuCible"
                      value={formData.lieuCible}
                      onChange={handleInputChange}
                      disabled={
                        userRoles.includes("COMMUNITY_MANAGER") &&
                        !(formData.statut === "planifié")
                      }
                    />
                  </div>

                  <div className="col">
                    <label htmlFor="exampleInputEmail1">Genre Cible</label>
                    <select
                      className="custom-select"
                      id="genreCible"
                      name="genreCible"
                      value={formData.genreCible}
                      onChange={handleInputChange}
                      disabled={
                        userRoles.includes("COMMUNITY_MANAGER") &&
                        !(formData.statut === "planifié")
                      }
                    >
                      {genresData.map((genre) => (
                        <option key={genre} value={genre}>
                          {genre}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>

              <div className="form-group">
                <div className="row">
                  <div className="col">
                    <label htmlFor="exampleInputEmail1">
                      ID de Publication
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="exampleInputEmail1"
                      placeholder="Id de publication"
                      name="idPublication"
                      value={formData.idPublication}
                      onChange={handleInputChange}
                      disabled={userRoles.includes("RESPONSABLE_MARKETING")}
                    />
                  </div>
                  <div className="col">
                    <label htmlFor="exampleInputEmail1">
                      Date de publication
                    </label>

                    <TextField
                      variant="outlined"
                      className="form-control"
                      value={formData.publicationDate}
                      defaultValue={formattedDateTime}
                      name="publicationDate"
                      onChange={onChangeStartDate}
                      id="datetime-local"
                      type="datetime-local"
                      disabled={
                        userRoles.includes("COMMUNITY_MANAGER") &&
                        !(formData.statut === "planifié")
                      }
                      InputLabelProps={{
                        shrink: true,
                      }}
                      size="small"
                      // className="mt-2"
                      //style={{ backgroundColor: "white"}}
                    />
                  </div>
                </div>
              </div>
              <div className="form-group">
                <label htmlFor="pieces-jointes">Pieces jointes</label>
                <div className="input-group">
                  <div className="custom-file">
                    <input
                      type="file"
                      className="custom-file-input"
                      id="PiecesJoints"
                      name="PiecesJoints"
                      onChange={handlePieceJointeChange}
                      value={formData.PiecesJoints}
                      disabled={
                        userRoles.includes("COMMUNITY_MANAGER") &&
                        !(formData.statut === "planifié")
                      }
                    />
                    <label
                      className="custom-file-label"
                      htmlFor="pieces-jointes"
                    >
                      {piecesJointesdata.length === 0
                        ? "Choose file"
                        : piecesJointesdata
                            .map((fichier) => fichier.name)
                            .join(", ")}
                    </label>
                  </div>
                  {piecesJointesdata.length > 0 && (
                    <div className="input-group-append">
                      <button
                        className="btn btn-outline-secondary"
                        type="button"
                        onClick={handleDeletePieceJointe}
                      >
                        <i className="fa fa-trash"></i>
                      </button>
                    </div>
                  )}
                </div>
                {/* affichage des images  */}
                <div className="row mt-3">
                  {piecesJointesdata.map((fichier, index) => (
                    <div key={index} className="col-sm-3 text-center mb-3">
                      <img
                        src={URL.createObjectURL(fichier)}
                        alt={fichier.name}
                        style={{ width: "100%", height: "80%" }}
                      />
                      <button
                        className="btn btn-outline-danger col-sm mt-3 mb-3"
                        type="button"
                        onClick={() => handleDeletePieceJointe(index)}
                      >
                        <i className="fa fa-trash"></i>
                      </button>
                    </div>
                  ))}
                </div>
                {/* end of affichage des images  */}
              </div>
            </div>
          </form>
        </div>
        <div className="card-footer">
          <div className="row">
            {userRoles &&
              Array.isArray(userRoles) &&
              userRoles.includes("RESPONSABLE_MARKETING") && (
                <div className="col">
                  <Button
                    className="btn btn-danger mr-2"
                    style={{ width: "150px" }}
                    onClick={handleRjectedPublication}
                    disabled={
                      isButtonDisabled ||
                      formData.statut !== "planifié" ||
                      !selectedPublication
                    }
                  >
                    Rejeter
                  </Button>
                  <Button
                    className="btn btn-warning"
                    style={{ width: "150px" }}
                    onClick={handleApprouvedPublication}
                    disabled={
                      isButtonDisabled ||
                      formData.statut !== "planifié" ||
                      !selectedPublication
                    }
                  >
                    Approuver
                  </Button>
                </div>
              )}

            {/* condition sur les button Ajouter + annuler */}
            <div className="col text-right">
              <Button
                className="btn btn-secondary mr-2"
                style={{ width: "150px" }}
                onClick={handleCancel}
              >
                Annuler
              </Button>
              <Button
                className="btn btn-dark"
                style={{ width: "150px" }}
                type="submit"
                onClick={handleUpdatePublication}
              >
                Modifier
              </Button>
            </div>
          </div>
        </div>
      </Modal>
      {/********************** /.Edit Modal */}
      <Snackbar
        open={openErrorAlert}
        autoHideDuration={2000}
        onClose={handleEroorClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleEroorClose} severity="error">
          {errorAlertText}
        </Alert>
      </Snackbar>
      <Snackbar
        open={openSuccessAlert}
        autoHideDuration={2000}
        onClose={handleSuccessClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleSuccessClose} severity="success">
          {successAlertText}
        </Alert>
      </Snackbar>
    </>
  );
}

export default TablePublication;
